import { takeEvery } from 'redux-saga'
import { call } from 'redux-saga/effects'
import notifyHoneybadger from 'helpers/notifyHoneybadger'
import { NOTIFY_HONEYBADGER } from 'actions/applicationActionTypes'

export function * notifyHoneybadgerSaga(action) {
  const { err } = action

  // since origin action is set as an attribute of this action
  yield call(notifyHoneybadger, { err, action: (action.action || action) })
}

export function * watchNotifyHoneybadger() {
  yield * takeEvery(NOTIFY_HONEYBADGER, notifyHoneybadgerSaga)
}



// WEBPACK FOOTER //
// ./src/sagas/notifyHoneybadgerSaga.js